// import img from "../components/images/product/valve1.png"
// flow
import Electromagnetic from "../components/images/product/flow/ELECTROMAGNETICFLOWMETER.jpg"
import Vortex from "../components/images/product/flow/VORTEX FLOWMETER.jpg"
import ThermalMass from "../components/images/product/flow/THERMAL MASS FLOWMETER1.jpg"
import Turbine from "../components/images/product/flow/TURBINE FLOWMETER.jpg"
import Mass from "../components/images/product/flow/MASS FLOWMETER.jpg"
import Ultrasonic1 from "../components/images/product/flow/ULTRASONIC FLOWMETER.jpg"
import gas from "../components/images/product/flow/gas flow.jpg"
import Mechanical from "../components/images/product/flow/Mechanical Type1.jpg"
import VariableAreaFlowmeters from "../components/images/product/VariableArea.jpg"
import CustodyTransferGas from "../components/images/product/flow/Custody Transfer Gas FM.jpeg"
import OvalGearFM from "../components/images/product/flow/9.Oval_Gear_FM.png"
// level
import RadarLevel from "../components/images/product/level/RadarLevel.jpeg"
import GuidedWaveradarLevel from "../components/images/product/level/GuidedWaveradarLevel.jpeg"
import UltrasonicLevel from "../components/images/product/level/UltrasonicLevel.jpeg"
import DPLevel from "../components/images/product/level/DPLevel.jpeg"
import PointLevel from "../components/images/product/level/PointLevel.png"
import Hydrostatical from "../components/images/product/level/hydrostatical1.png"
import CapacitanceLevel from "../components/images/product/level/Capacitance Level.jpeg"
import Float from "../components/images/product/level/Float.jpeg"
// valve
import pcsball2 from "../components/images/product/valve/2pcsballvalve.png"
import pcsball3 from "../components/images/product/valve/3pcsballvalve.png"
import wayball34 from "../components/images/product/valve/34wayballvalve.png"
import wafertypeballvalve from "../components/images/product/valve/wafertypeballvalve.png"
import FepPfalinedBallValve from "../components/images/product/valve/FepPfalinedBallValve.png"
import Upvcballvaleve from "../components/images/product/valve/Upvcballvaleve.png"
import ppballvalve from "../components/images/product/valve/ppballvalve.png"
import LineedButterfly from "../components/images/product/valve/LineedButterfly.png"
import LineedDoubleflangeButterfly from "../components/images/product/valve/LineedDoubleflangeButterfly.png"
import LinedlugtypeButterfly from "../components/images/product/valve/Linedlug typeButterfly.png"
import feppfaLineedButterfly from "../components/images/product/valve/feppfaLineedButterfly.png"
// Temperature
import float1 from "../components/images/product/temperature/float.png"
import Head1 from "../components/images/product/temperature/head.png"
//pressure
import dpt from "../components/images/product/pressure/dpt.png"
import Absoluteandgauge from "../components/images/product/pressure/Absoluteandgauge.png"
//liquid
import ph from "../components/images/product/liquid/ph.png"
import orp from "../components/images/product/liquid/orp.png"
import CONDUCTIVITYANALYZERS from "../components/images/product/liquid/CONDUCTIVITY ANALYZERS.png"
import AMMONIUMANDNITRATE from "../components/images/product/liquid/AMMONIUM AND NITRATE.png"
import analog_chlorine_dioxide_ from "../components/images/product/liquid/analog_chlorine_dioxide_.png"
import DISSOLVEDOXYGENANALYZERS from "../components/images/product/liquid/DISSOLVED OXYGEN ANALYZERS.png"
import SPECTOMETER from "../components/images/product/liquid/SPECTOMETER.png"
import tubidity from "../components/images/product/liquid/tubidity.png"
import ALUMINUM from "../components/images/product/liquid/aluminum_analyzer.jpg"
import CHLORINEANALYZERS from "../components/images/product/liquid/CHLORINE ANALYZERS.jpg"
import CHROMATE from "../components/images/product/liquid/CHROMATE.jpg"
import IRON from "../components/images/product/liquid/IRON.jpg"
import NITRITE from "../components/images/product/liquid/NITRITE.jpg"
import Silicaanalyzer from "../components/images/product/liquid/Silica analyzer.jpeg"
import sodiumanalyzer from "../components/images/product/liquid/sodium_analyzer.jpg"
import SWAS from "../components/images/product/liquid/SWAS.jpg"
import TOC from "../components/images/product/liquid/TOC.jpg"
import TOTALPHOSPHORUS from "../components/images/product/liquid/TOTAL PHOSPHORUS.jpg"
import totalnitrogenanalyzer from "../components/images/product/liquid/total-nitrogen-analyzer-open.jpg"
import WATERhardnessanalyzer from "../components/images/product/liquid/WATER hardness_analyzer_open.jpg"
import watersamplerliquistation from "../components/images/product/liquid/water sampler liquistation.jpg"
//vibration
import vibsensors from "../components/images/product/vibration/sensors.png"
import vibvelocity from "../components/images/product/vibration/vib-velocity.png"
import vibvelocityDisplacement from "../components/images/product/vibration/vib-velocityDisplacement.png"
import vibAmplitudeBearingCondition from "../components/images/product/vibration/vib-AmplitudeBearingCondition.jpg"
import VibrationVelocityandDisplacement from "../components/images/product/vibration/Vibration VelocityandDisplacement.png"
import VibrationAmplitudeandBearingCondition from "../components/images/product/vibration/Vibration Amplitude and Bearing Condition.jpeg"
const products = [
  {
    id: 1,
    name: "Electromagnetic Flowmeter",
    type: "Flow Measurement",
    // description: "Accurate digital sensor for industrial use.",
    price: 2999,
    image: Electromagnetic,
    pdf: "/pdf/Flow/1.EMF.pdf",
    specifications: [
      { no: 1, description: "Series", material: "Proline Promag H" },
      { no: 2, description: "End Connector", material: "WCB / S.S. 304 / S.S. 316" },
      { no: 3, description: "Ball", material: "S.S. 304 / S.S. 316" },
      { no: 4, description: "Ball Seat", material: "PTFE / CFT / GFT" },
      { no: 5, description: "Stem Pin", material: "AISI S.S. 304 / S.S. 316" },
      { no: 6, description: "Body Seat", material: "Grafoil" },
      { no: 7, description: "Conn O Ring", material: "PTFE / CFT / GFT" },
      { no: 8, description: "Stem Seat Bottom", material: "PTFE / CFT / GFT" },
      { no: 9, description: "Stem O Ring", material: "PTFE / CFT / GFT" },
      { no: 10, description: "Stem Seat Top", material: "Grafoil" },
      { no: 11, description: "Gland", material: "S.S. 304 / S.S. 316" },
      { no: 12, description: "Fitting Nut & Spring Washer", material: "H.T. / S.S. 202" },
      { no: 13, description: "Pneumatic Actuator", material: "Standard" },
    ],
  },
  {
    id: 2,
    name: "Vortex Flowmeter",
    type: "Flow Measurement",
    price: 2999,
    image: Vortex,
    pdf: "/pdf/Flow/2.Vortex_FM.pdf",
  },
  {
    id: 3,
    name: "Mass Flowmeter ",
    type: "Flow Measurement",
    price: 2999,
    image: Mass,
    pdf: "/pdf/Flow/3.Coriolis_FM.pdf",
  },
  {
    id: 4,
    name: "Thermal Mass Flowmeter",
    type: "Flow Measurement",
    price: 2999,
    image: ThermalMass,
    pdf: "/pdf/Flow/4.Thermalmass_FM.pdf",
  },

  {
    id: 5,
    name: "Ultrasonic Gas Flowmeter    ",
    type: "Flow Measurement",
    price: 2999,
    image: gas,
    pdf: "/pdf/Flow/5.Ultrasonic_Gas_FM.pdf",
  },
  {
    id: 6,
    name: "Custody Transfer Gas Flowmeter",
    type: "Flow Measurement",
    price: 2999,
    image: CustodyTransferGas,
    pdf: "/pdf/Flow/7.Custody_Transfer_Gas_FM.pdf",
  },
  {
    id: 7,
    name: "Ultrasonic clamp Flowmeter ",
    type: "Flow Measurement",
    price: 2999,
    image: Ultrasonic1,
    pdf: "/pdf/Flow/6.Ultrasonic_clamp_FM.pdf",
  },

  {
    id: 8,
    name: "Turbine Flowmeter    ",
    type: "Flow Measurement",
    price: 2999,
    image: Turbine,
    pdf: "/pdf/Flow/8.Turbine_FM.pdf",
  },
  {
    id: 9,
    name: "Oval Gear Flowmeter",
    type: "Flow Measurement",
    price: 2999,
    image: OvalGearFM,
    pdf: "/pdf/Flow/9.Oval_Gear_FM.pdf",
  },

  {
    id: 10,
    name: "Variable Area Flowmeters",
    type: "Flow Measurement",
    price: 2999,
    image: VariableAreaFlowmeters,
    pdf: "/pdf/Flow/10.Variable_Area_FM.pdf",
  },
  {
    id: 11,
    name: "Woltman Type Flowmeters ",
    type: "Flow Measurement",
    price: 2999,
    image: Mechanical,
    pdf: "/pdf/Flow/11.Woltman_Type_FM.pdf",
  },

  // Level Measurement
  {
    id: 21,
    name: "Radar Level Transmitter ",
    type: "Level Measurement",

    price: 2999,
    image: RadarLevel,
  },
  {
    id: 22,
    name: "Guided Wave Radar Level ",
    type: "Level Measurement",

    price: 2999,
    image: GuidedWaveradarLevel,
  },
  {
    id: 23,
    name: "Ultrasonic Level",
    type: "Level Measurement",

    price: 2999,
    image: UltrasonicLevel,
  },
  {
    id: 24,
    name: "DP Level",
    type: "Level Measurement",

    price: 2999,
    image: DPLevel,
  }, {
    id: 25,
    name: "Point level    ",
    type: "Level Measurement",

    price: 2999,
    image: PointLevel,
  },
  {
    id: 26,
    name: "Hydrostatical    ",
    type: "Level Measurement",

    price: 2999,
    image: Hydrostatical,
  }
  , {
    id: 27,
    name: "Capacitance Level    ",
    type: "Level Measurement",

    price: 2999,
    image: CapacitanceLevel,
  }
  , {
    id: 28,
    name: "Float switch",
    type: "Level Measurement",

    price: 2999,
    image: Float,
  },


  {
    id: 40,
    name: "Absolute and gauge pressure measurement",
    type: "Pressure Measurement",

    price: 2999,
    image: Absoluteandgauge,
  },
  {
    id: 41,
    name: "Differential pressure flow measurement",
    type: "Pressure Measurement",

    price: 2999,
    image: dpt,
  },
  {
    id: 43,
    name: "Head mount ",
    type: "Temperature Measurement",

    price: 2999,
    image: Head1,
  },
  {
    id: 44,
    name: "Float Mount ",
    type: "Temperature Measurement",

    price: 2999,
    image: float1,
  },
  {
    id: 50,
    name: "2 Pcs Ball Valve",
    type: "Valve",
    typeName: "Ball Valve",
    price: 4500,
    image: pcsball2,
    specifications: [
      { no: 1, description: "Body", material: "WCB / S.S. 304 / S.S. 316" },
      { no: 2, description: "End Connector", material: "WCB / S.S. 304 / S.S. 316" },
      { no: 3, description: "Ball", material: "S.S. 304 / S.S. 316" },
      { no: 4, description: "Ball Seat", material: "PTFE / CFT / GFT" },
      { no: 5, description: "Stem Pin", material: "AISI S.S. 304 / S.S. 316" },
      { no: 6, description: "Body Seat", material: "Grafoil" },
      { no: 7, description: "Conn O Ring", material: "PTFE / CFT / GFT" },
      { no: 8, description: "Stem Seat Bottom", material: "PTFE / CFT / GFT" },
      { no: 9, description: "Stem O Ring", material: "PTFE / CFT / GFT" },
      { no: 10, description: "Stem Seat Top", material: "Grafoil" },
      { no: 11, description: "Gland", material: "S.S. 304 / S.S. 316" },
      { no: 12, description: "Fitting Nut & Spring Washer", material: "H.T. / S.S. 202" },
      { no: 13, description: "Pneumatic Actuator", material: "Standard" },
    ],
  },
  {
    id: 52,
    name: "3 Pcs Ball Valve",
    type: "Valve",
    typeName: "Ball Valve",
    specifications: [
      { no: 1, description: "Body", material: "WCB / S.S. 304 / S.S. 316" },
      { no: 2, description: "End Connector", material: "WCB / S.S. 304 / S.S. 316" },
      { no: 3, description: "Ball", material: "S.S. 304 / S.S. 316" },
      { no: 4, description: "Ball Seat", material: "PTFE / CFT / GFT" },
      { no: 5, description: "Stem Pin", material: "AISI 410/S.S. 304 / S.S. 316" },
      { no: 6, description: "Gland With Bush", material: "S.S. 304" },
      { no: 7, description: "Stem Seat  ", material: "PTFE / CFT / GFT" },
      { no: 8, description: "Stud & Socket Nut", material: "M.S / S.S" },
      { no: 9, description: "Pneumatic Actuator", material: "Standard" },
    ],

    price: 4500,
    image: pcsball3,

  },
  {
    id: 53,
    name: "3 / 4 Way Ball Valve Screwed end ",
    type: "Valve",
    typeName: "Ball Valve",
    specifications: [
      { no: 1, description: "Body", material: "WCB / S.S. 304 / S.S. 316" },
      { no: 2, description: "End Connector", material: "WCB / S.S. 304 / S.S. 316" },
      { no: 3, description: "Ball", material: "S.S. 304 / S.S. 316" },
      { no: 4, description: "Ball Seat", material: "PTFE / CFT / GFT" },
      { no: 5, description: "Stem Pin", material: "AISI S.S. 304 / S.S. 316" },
      { no: 6, description: "Body Seat", material: "Grafoil" },
      { no: 7, description: "Conn O Ring", material: "PTFE / CFT / GFT" },
      { no: 8, description: "Stem Seat Bottom", material: "PTFE / CFT / GFT" },
      { no: 9, description: "Stem O Ring", material: "PTFE / CFT / GFT" },
      { no: 10, description: "Stem Seat Top", material: "Grafoil" },
      { no: 11, description: "Gland", material: "S.S. 304 / S.S. 316" },
      { no: 12, description: "Fitting Nut & Spring Washer", material: "H.T. / S.S. 202" },
      { no: 13, description: "Pneumatic Actuator", material: "Standard" },
    ],

    price: 4500,
    image: wayball34,

  },
  {
    id: 54,
    name: "Wafer type Ball Valve",
    type: "Valve",
    typeName: "Ball Valve",

    image: wafertypeballvalve,

  },
  {
    id: 55,
    name: "FEP / PFA lined Ball Valve",
    type: "Valve",
    typeName: "Ball Valve",

    price: 4500,
    image: FepPfalinedBallValve,

  },
  {
    id: 56,
    name: "UPVC Ball Valve",
    type: "Valve",
    typeName: "Ball Valve",
    image: Upvcballvaleve,
  },
  {
    id: 57,
    name: "PP Ball Valve",
    type: "Valve",
    typeName: "Ball Valve",
    description: "Cira Technology offers ISO 5211 Standard pneumatic actuator operated investment casting WCB/CF8/CF8M ball valve in threepiece design. Engineering for multiple ON/OFF operations in the down stream.",
    price: 4500,
    image: ppballvalve,

  },
  {
    id: 58,
    name: "Rubber lined Butterfly Valve",
    type: "Valve",
    typeName: "Butterfly Valve",

    image: LineedButterfly,

  },
  {
    id: 59,
    name: "Rubber lined double flanged Butterfly Valve",
    type: "Valve",
    typeName: "Butterfly Valve",

    price: 4500,
    image: LineedDoubleflangeButterfly,

  },
  {
    id: 60,
    name: "Rubber lined lug type Butterfly Valve",
    type: "Valve",
    typeName: "Butterfly Valve",

    price: 4500,
    image: LinedlugtypeButterfly,

  },
  {
    id: 61,
    name: "FEP / PFA lined Butterfly Valve",
    type: "Valve",
    typeName: "Butterfly Valve",

    price: 4500,
    image: feppfaLineedButterfly,

  },
  {
    id: 70,
    name: "Tunable Diode Laser Spectrometers",
    type: "Gas Analyser",

    price: 4500,


  },
  {
    id: 71,
    name: "Process Gas Chromatographs",
    type: "Gas Analyser",

    price: 4500,


  },
  {
    id: 72,
    name: "Oxygen Analyzers",
    type: "Gas Analyser",

    price: 4500,


  },
  {
    id: 73,
    name: "Gas Density/Hydrogen Purity Analyzer",
    type: "Gas Analyser",



  },
  {
    id: 74,
    name: "Non-Dispersive Infrared Gas Analyzers (NDIR)",
    type: "Gas Analyser",



  },
  {
    id: 91,
    name: "PH ANALYZERS",
    type: "Liquid Analyzers",

    price: 4500,
    image: ph,

  },
  {
    id: 92,
    name: "ORP ANALYZERS",
    type: "Liquid Analyzers",

    price: 4500,
    image: orp,

  },
  {
    id: 93,
    name: "CONDUCTIVITY ANALYZERS",
    type: "Liquid Analyzers",

    price: 4500,
    image: CONDUCTIVITYANALYZERS,

  },
  {
    id: 94,
    name: "AMMONIUM AND NITRATE Analyzers",
    type: "Liquid Analyzers",

    price: 4500,
    image: AMMONIUMANDNITRATE,

  },
  {
    id: 95,
    name: "ANALOG CHLORINE DIOXIDE Analyzers",
    type: "Liquid Analyzers",

    image: analog_chlorine_dioxide_,

  },
  {
    id: 96,
    name: "DISSOLVED OXYGEN ANALYZERS",
    type: "Liquid Analyzers",

    image: DISSOLVEDOXYGENANALYZERS,

  },
  {
    id: 97,
    name: "SPECTOMETER ANALYZERS",
    type: "Liquid Analyzers",

    price: 4500,
    image: SPECTOMETER,

  },
  {
    id: 98,
    name: "TUBIDITY ANALYZERS",
    type: "Liquid Analyzers",

    price: 4500,
    image: tubidity,

  },
  {
    id: 99,
    name: "ALUMINUM ANALYZERS",
    type: "Liquid Analyzers",

    price: 4500,
    image: ALUMINUM,

  },
  {
    id: 100,
    name: "CHLORINE ANALYZERS",
    type: "Liquid Analyzers",

    price: 4500,
    image: CHLORINEANALYZERS,

  },
  {
    id: 101,
    name: "CHROMATE ANALYZERS",
    type: "Liquid Analyzers",

    price: 4500,
    image: CHROMATE,

  },
  {
    id: 102,
    name: "IRON ANALYZERS",
    type: "Liquid Analyzers",

    image: IRON,

  },
  {
    id: 103,
    name: "NITRITE ANALYZERS",
    type: "Liquid Analyzers",

    price: 4500,
    image: NITRITE,

  },
  {
    id: 104,
    name: "SILICA ANALYZERS",
    type: "Liquid Analyzers",

    price: 4500,
    image: Silicaanalyzer,

  },
  {
    id: 105,
    name: "SODIUM ANALYZERS",
    type: "Liquid Analyzers",

    image: sodiumanalyzer,

  },
  {
    id: 106,
    name: "SWAS ANALYZERS",
    type: "Liquid Analyzers",

    price: 4500,
    image: SWAS,

  },
  {
    id: 107,
    name: "TOC ANALYZERS",
    type: "Liquid Analyzers",

    price: 4500,
    image: TOC,

  },
  {
    id: 108,
    name: "TOTAL PHOSPHORUS ANALYZERS",
    type: "Liquid Analyzers",

    image: TOTALPHOSPHORUS,

  },
  {
    id: 109,
    name: "TOTAL NITROGEN ANALYZERS",
    type: "Liquid Analyzers",

    image: totalnitrogenanalyzer,

  },
  {
    id: 110,
    name: "WATER  HARDNESS ANALYZERS",
    type: "Liquid Analyzers",

    price: 4500,
    image: WATERhardnessanalyzer,

  },
  {
    id: 111,
    name: "WATER SAMPLER LIQUITATION ANALYZERS",
    type: "Liquid Analyzers",

    price: 4500,
    image: watersamplerliquistation,

  },
  {
    id: 120,
    name: "Vibration Sensors",
    type: "vibration monitoring",
    price: 4500,
    image: vibsensors,

  },
  {
    id: 121,
    name: "Vibration Velocity - IRD301 ",
    type: "vibration monitoring",
    price: 4500,
    image: vibvelocity,

  },
  {
    id: 122,
    name: "Vibration Vibvelocity & Displacement  - IRD306DP ",
    type: "vibration monitoring",
    price: 4500,
    image: vibvelocityDisplacement,

  },
  {
    id: 123,
    name: "Vibration Amplitude Bearing Condition -IRD811D",
    type: "vibration monitoring",
    price: 4500,
    image: vibAmplitudeBearingCondition,

  },
  {
    id: 124,
    name: "Vibration Velocity and Displacement -IRD306",
    type: "vibration monitoring",
    price: 4500,
    image: VibrationVelocityandDisplacement,

  },
  {
    id: 125,
    name: "Vibration Amplitude and Bearing Condition-IRD811",
    type: "vibration monitoring",
    price: 4500,
    image: VibrationAmplitudeandBearingCondition,

  },

];

export default products;
